import React from 'react';
import PropTypes from 'prop-types';

import Text from '../Text/Text';

const Card = ({
  children, styleContainer, showHeader, headerTitle, headerRight,
  headerBordered, styleBodyContainer, footer, footerBordered, headerLeft, required
}) => {
  return (
    <div
      className={`bg-white dark:bg-[#1b263b] border border-transparent dark:border-[#415a77]/60
      h-max rounded-[8px] w-full shadow-card flex flex-1 flex-col ${styleContainer}`}
    >
      {showHeader && (
        <div className={`flex flex-row flex-wrap md:flex-nowrap items-center justify-between gap-[8px]
         px-[12px] py-[12px] min-h-[56px] md:px-[30px] md:py-0 md:h-[70px]
         ${headerBordered ? 'border-b border-whiteHover dark:border-[#1b263b]' : ''}`}
        >
          {headerLeft}
          {headerTitle && <Text text={headerTitle} bold textStyle="text-[17px] capitalize" required={required} />}
          {headerRight}
        </div>
      )}
      <div className={`px-[12px] pt-[12px] pb-0 md:px-[30px] md:pt-[30px] z-0 ${styleBodyContainer}`}>
        {children}
      </div>
      {
        footer && (
          <div className={`px-[12px] py-[12px] md:px-[30px] md:py-[20px] ${footerBordered
            ? 'border-t border-whiteHover dark:border-[#1b263b]' : ''}`}
          >
            {footer}
          </div>
        )
      }
    </div>
  );
};

Card.propTypes = {
  children: PropTypes.node.isRequired,
  headerRight: PropTypes.node,
  headerLeft: PropTypes.node,
  footer: PropTypes.node,
  headerTitle: PropTypes.string,
  styleContainer: PropTypes.string,
  styleBodyContainer: PropTypes.string,
  showHeader: PropTypes.bool,
  headerBordered: PropTypes.bool,
  footerBordered: PropTypes.bool,
  required: PropTypes.bool,
};

Card.defaultProps = {
  styleContainer: '',
  styleBodyContainer: '',
  headerTitle: '',
  headerRight: undefined,
  headerLeft: undefined,
  footer: undefined,
  showHeader: false,
  required: false,
  headerBordered: true,
  footerBordered: true,
};
export default Card;
